import React from 'react';
import { Box, Typography, Button, Container, Stack, Grid, Snackbar, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WifiIcon from '@mui/icons-material/Wifi';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import QrCodeIcon from '@mui/icons-material/QrCode';
import InfoIcon from '@mui/icons-material/Info';
import DescriptionIcon from '@mui/icons-material/Description';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmailIcon from '@mui/icons-material/Email';
import { useLocation, useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { showMessage } from '../utils';
import { isInApp } from '../utils/environment';


// 自定义样式组件
const StyledContainer = styled(Container)({
  padding: 0,
  backgroundColor: '#fff',
  minHeight: '100vh',
});

const CouponCard = styled(Box)({
  padding: '24px',
  backgroundColor: '#000',
  borderRadius: '12px',
  margin: '0 16px 24px',
  color: '#fff',
});

const InfoCard = styled(Box)({
  padding: '24px',
  background: '#FFFFFF',
  border: '1px solid #E5E7EB',
  borderRadius: '12px',
  margin: '0 16px 16px',
});

const RewardDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const couponData = location.state?.couponData;

  // 处理返回
  const handleBack = () => {
    navigate(-1);
  };

  // 处理复制代码
  const handleCopyCode = async () => {
    try {
      await navigator?.clipboard?.writeText(couponData?.code);
      showMessage('Code copied successfully', 'success');
    } catch (err) {
      // console.error('Failed to copy code:', err);
    }
  };

  return (
    <StyledContainer maxWidth="sm">
      {/* 顶部导航栏 */}
      {
        !isInApp() && (
          <Box 
        sx={{ 
          px: 2,
          py: 1.5,
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid #F3F4F6'
        }}
      >
        <ChevronLeftIcon 
          onClick={handleBack}
          sx={{ 
            cursor: 'pointer',
            fontSize: 24,
            color: '#000'
          }}
        />
        <Typography 
          sx={{ 
            flex: 1,
            textAlign: 'center',
            fontSize: '17px',
            fontWeight: 600,
            color: '#000'
          }}
        >
          Reward Details
        </Typography>
            <Box sx={{ width: 24 }} /> {/* 占位，保持标题居中 */}
          </Box>
        )
      }

      {/* 优惠券信息卡片 - 修改为左右两栏布局 */}
      <CouponCard>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}>
          <Box sx={{ flex: 1 }}>
            <Typography 
              sx={{ 
                fontSize: '18px',
                fontWeight: 900,
                mb: 1,
                fontFamily: 'Roboto',
                color: '#FFFFFF'
              }}
            >
              {couponData?.name}
            </Typography>
            <Chip 
              label="Best Value"
              sx={{
                bgcolor: '#1677FF',
                color: '#fff',
                height: '24px',
                fontSize: '12px',
                fontWeight: 500,
                borderRadius: '4px',
                mb: 2,
                fontFamily: 'Roboto'
              }}
            />
            <Typography 
              sx={{ 
                fontSize: '32px',
                fontWeight: 700,
                mb: 1,
                fontFamily: 'Roboto',
                color: '#FFFFFF'
              }}
            >
              ${couponData?.facePrice} OFF
            </Typography>
            <Typography 
              sx={{ 
                fontSize: '16px',
                fontFamily: 'Roboto',
                color: '#FFFFFF',
                opacity: 0.8,
                fontWeight: 400
              }}
            >
              {couponData?.code}
            </Typography>
          </Box>
          <Box sx={{ 
            bgcolor: '#fff',
            // p: 1.5,
            borderRadius: '8px',
            minWidth: '90px',
            height: '90px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ml: 2
          }}>
            <QRCode 
              value={couponData?.code || ''} 
              size={72}
              level="H"
            />
          </Box>
        </Box>
      </CouponCard>

      {/* 状态信息卡片 */}
      <InfoCard>
        <Box sx={{ 
          display: 'flex',
          alignItems: 'center',
          mb: 2.5
        }}>
          <InfoIcon sx={{ 
            color: '#007AFF',
            mr: 1.5,
            fontSize: 20
          }} />
          <Typography sx={{ 
            fontSize: '17px',
            fontWeight: 600
          }}>
            Status Information
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography sx={{ color: '#6B7280', fontSize: '12px', mb: 0.5, fontFamily: 'Roboto', fontWeight: 400 }}>
              Current Status
            </Typography>
            <Typography sx={{ color: '#007AFF', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              {couponData?.status === 1 ? 'Active' : 'Expired'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ color: '#6B7280', fontSize: '12px', mb: 0.5, fontFamily: 'Roboto', fontWeight: 400 }}>
              Purchase Date
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              {couponData?.purchaseDate}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ color: '#6B7280', fontSize: '12px', mb: 0.5, fontFamily: 'Roboto', fontWeight: 400 }}>
              Valid Until
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              {new Date(couponData?.validEndTime).toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ color: '#6B7280', fontSize: '12px', mb: 0.5, fontFamily: 'Roboto', fontWeight: 400 }}>
              Usage Status
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              {couponData?.status === 1 ? 'Unused' : 'Used'}
            </Typography>
          </Grid>
        </Grid>
      </InfoCard>

      {/* 优惠券详情卡片 */}
      <InfoCard>
        <Box sx={{ 
          display: 'flex',
          alignItems: 'center',
          mb: 2.5
        }}>
          <DescriptionIcon sx={{ 
            color: '#007AFF',
            mr: 1.5,
            fontSize: 20
          }} />
          <Typography sx={{ 
            fontSize: '17px',
            fontWeight: 600
          }}>
            Coupon Details
          </Typography>
        </Box>
        <Stack spacing={2}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography sx={{ color: '#6B7280', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              Minimum Purchase
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              ${couponData?.actualPrice}
            </Typography>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography sx={{ color: '#6B7280', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              Usage Limit
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              One-time use
            </Typography>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography sx={{ color: '#6B7280', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              Purchase Price
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              ${couponData?.purchasePrice}
            </Typography>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography sx={{ color: '#6B7280', fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400 }}>
              Savings
            </Typography>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: 'Roboto' }}>
              ${couponData?.savings}
            </Typography>
          </Box>
        </Stack>
      </InfoCard>

      {/* 底部按钮 */}
      <Stack 
        direction="row" 
        spacing={2} 
        sx={{ 
          px: 2,
          mt: 3
        }}
      >
        <Button 
          variant="contained" 
          startIcon={<ContentCopyIcon sx={{ fontSize: 20 }} />}
          onClick={handleCopyCode}
          sx={{ 
            backgroundColor: '#000', 
            color: '#fff', 
            flex: 1,
            borderRadius: '12px',
            textTransform: 'none',
            fontSize: '15px',
            fontWeight: 500,
            py: 1.5,
            '&:hover': {
              backgroundColor: '#000'
            }
          }}
        >
          Copy Code
        </Button>
        {/* <Button 
          variant="contained" 
          startIcon={<EmailIcon sx={{ fontSize: 20 }} />}
          sx={{ 
            backgroundColor: '#000', 
            color: '#fff', 
            flex: 1,
            borderRadius: '12px',
            textTransform: 'none',
            fontSize: '15px',
            fontWeight: 500,
            py: 1.5,
            '&:hover': {
              backgroundColor: '#000'
            }
          }}
        >
          Email Receipt
        </Button> */}
      </Stack>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        message="Code copied successfully"
        sx={{
          '& .MuiSnackbarContent-root': {
            bgcolor: '#000',
            borderRadius: '12px'
          }
        }}
      />
    </StyledContainer>
  );
};

export default RewardDetails; 